export default "/_next/static/chunks/fonts/Nunito-Bold-latin-18729a5349725f9fe7a150721620cfe8.woff2";